<template>
	<div id="login">
		<div class="container">
			<a href="https://www.sankei.com/nie/nie.html"><img src="../../assets/img/intro-common-manabou-logo.jpg" class="logo"></a>
			<h2>かんたん号外くん</h2>
			<div class="login-form">
				<h3>ログイン</h3>
				<input @keyup.enter="handleSubmit" type="text" placeholder="ログインID" v-model="userData.login_id" required>
				<input @keyup.enter="handleSubmit" type="password" placeholder="パスワード" v-model="userData.password" required>
				<div>
					<input class="regulation-check" @keyup.enter="handleSubmit" type="checkbox" v-model="userData.regulation" required>
					<a class="link" href="./regulation" target="_blank">ルール</a>を守って利用する
				</div>
				<button type="submit" class="btn btn-blue" @click="handleSubmit">
					<img src="../../assets/img/loader.gif" class="loader" v-if="isLoading"/>
					ログイン
				</button>
				<p class="login-error" v-if="hasError">
					※ログインIDまたはパスワードが間違っています。先生に確認してください。
				</p>
				<p class="login-error" v-if="hasErrorMiss">
					※入力内容を確認してください。
				</p>
				<p class="login-error" v-if="hasErrorRegulation">
					※ルールを守って利用するにチェックを入れてください。
				</p>
				<div>
					<p class="support">
						<a class="link" href="https://id.sankei.jp/e/1697" target="_blank">新規利用お申し込み</a>
					</p>
				</div>
			</div>
			<table class="contact-table">
				<tr>
					<th>お問い合わせ</th>
					<td>
						<p>東京本社NIE担当　</p>
						<p><a href="mailto:nie-tokyo@sankei.co.jp">nie-tokyo@sankei.co.jp</a></p>
					</td>
				</tr>
			</table>
			<ul v-for="item in list" :key="item.id">
				<li><img :src="item.thumbnail_url" alt="image new"/></li>
			</ul>
		</div>

	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
	import defaultLogo from '../../assets/img/logos/logo.svg'

	export default {
		name: 'Login',
		data () {
			return {
				logoUrl: defaultLogo,
				accessToken: '',
				hasError: false,
				hasErrorMiss: false,
				hasErrorRegulation: false,
				userData: {
					login_id: '',
					password: ''
				},
				isLoading: false
			}
		},
		beforeRouteEnter (to, from, next) {
			next()
		},
		computed: {
			...mapGetters('question', ['list'])
		},
		methods: {
			...mapActions('users', ['getToken']),
			/**
			 * Submit to Newspaper
			*/

			handleSubmit () {
				if (this.userData.login_id !== '' && this.userData.password !== '' && this.userData.regulation) {
					this.isLoading = true
					this.getToken(this.userData).then(() => {
						this.$router.push('create')
						window.scrollTo(0, 0)
					}).then(() => {
						this.isLoading = false
					}).catch(() => {
						this.hasError = true
						this.hasErrorMiss = false
						this.hasErrorRegulation = false
						this.isLoading = false
					})
					console.log("1")
				} else if (this.userData.login_id === '' || this.userData.password === '') {
					this.hasError = false
					this.hasErrorMiss = true
					this.hasErrorRegulation = false
				} else if (this.userData.regulation !== true) {
					this.hasError = false
					this.hasErrorMiss = false
					this.hasErrorRegulation = true
				} else {
					this.hasError = false
					this.hasErrorMiss = true
					this.hasErrorRegulation = false
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	#login {
		position: absolute;
		top: 62%;
		transform: translateY(-60%);
		width: 100%;

		.logo {
			width: 50%;
			max-width: 100px;
			margin: auto;
			display: block;
		}

		h2 {
			font-size: 2rem;
			text-align: center;
			font-weight: bold;
			margin: 10px 0 20px;
		}

		.login {
			&-form {
				width: 60%;
				max-width: 300px;
				margin: auto;
				border: 1px solid #3c3c3c;
				padding: 20px 30px;
				border-radius: 2px;

				h3 {
					font-size: 1.5rem;
					margin-bottom: 20px;
					font-weight: normal;
				}

				input[type=text] {
					position: initial;
					transform: none;
					display: block;
				}

				input {
					height: 30px;
					margin-bottom: 10px;
					width: 100%;
					box-sizing: border-box;
					padding: 20px 20px;
					font-size: 1rem;
					font-weight: normal;
					border: 1px solid #DDDDDD;
					border-radius: 4px;
				}

				.regulation-check {
					width: 10%;
					padding: 5%;
					margin-right: 2%;
				}

				.link {
					color: #1C7CD5;
					font-weight: bolder;
				}

				::placeholder {
					font-size: 1rem;
					font-weight: normal;
				}

				.support {
					text-align: center;
					margin-top: 2%;
				}

				.btn {
					width: 100%;
					background: #06517B;
					border: 1px solid #1C7CD5;
					border-radius: 5px;
					color: #ffffff;
					display: block;
					padding: 10px 20px;
					box-sizing: border-box;
					text-align: center;
					font-size: 1.5rem;

					&:hover {
						opacity: .95;
						cursor: pointer;
					}
				}
			}

			&-error {
				color: #FF0000;
				padding: 15px 0 0;
				text-align: center;
				margin: 0 -10px;
				font-size: .85rem;
				line-height: 1.2;
			}
		}

		.btn {
			position: relative;

			img {
				width: 20px;
				position: absolute;
				left: 10%;
				top: 50%;
				transform: translateY(-50%);
			}
		}

		.contact-table {
			margin: 20px auto;
			th, td {
				padding: 10px 30px 10px 15px;
			}
			th {
				vertical-align: middle;
				font-weight: bold;
				background-color: #75808c;
 				color: #fff;
			}
			td {
				p {
					line-height: 130%;
				}
				a {
					color: #1C7CD5;
				}
				background-color: #efefef;
    			border-bottom: 1px solid #fff;
			}
		}
	}
</style>